import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import et from './locales/et.json';
import ru from './locales/ru.json';
import ua from './locales/ua.json';

const resources = {
  en: { translation: en },
  et: { translation: et },
  ru: { translation: ru },
  ua: { translation: ua },
};

const NODE_ENV = process.env.NODE_ENV as string | undefined;
const REACT_APP_DEFAULT_LANG = process.env.REACT_APP_DEFAULT_LANG as string | undefined;
const isProd = NODE_ENV === 'production';
const allowed = ['en', 'et', 'ru', 'ua'];
const normalizeLanguage = (value?: string): string => {
  const base = (value || '').trim().toLowerCase().split('-')[0];
  const normalized = base === 'uk' ? 'ua' : base;
  return allowed.includes(normalized) ? normalized : 'et';
};
const envDefault = normalizeLanguage(REACT_APP_DEFAULT_LANG);
const defaultLng = allowed.includes(envDefault)
  ? envDefault
  : (isProd ? 'et' : 'et');

const detectionOrder = isProd
  ? ['localStorage', 'htmlTag'] // ignore navigator in prod so fallback takes effect
  : ['localStorage', 'navigator', 'htmlTag'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: defaultLng,
    debug: false,
    supportedLngs: ['en', 'et', 'ru', 'ua'],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: detectionOrder,
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => normalizeLanguage(lng),
    }
  })
  .then(() => {
    try {
      if (typeof document !== 'undefined') {
        const normalized = normalizeLanguage(i18n.resolvedLanguage || i18n.language || defaultLng);
        if (i18n.language !== normalized) {
          i18n.changeLanguage(normalized);
        }
        document.documentElement.lang = normalized;
      }
    } catch {}
  });

export default i18n;
